import { createUUID } from '../../common/services/uuid.service'
import { blockEditComponents } from './block-edit-components'
import { blockToolboxOptions } from './block-toolbox-options'

class BlockEditService {
  buildNewBlock (blockToolboxOptionId, props = {}) {
    const newKey = createUUID()
    const blockToolboxOption = blockToolboxOptions.find(({ id }) => id === blockToolboxOptionId) || {}
    const newConfig = { props: {} }

    let defaultConfig

    try {
      defaultConfig = blockToolboxOption.defaultConfig ? JSON.parse(JSON.stringify(blockToolboxOption.defaultConfig)) : newConfig
    } catch (error) {
      defaultConfig = newConfig
    }
    const newBlock = {
      key: newKey,
      type: blockToolboxOption.type,
      ...defaultConfig,
      ...props
    }

    return { newBlock, shouldEditOnDrop: blockToolboxOption.shouldEditOnDrop }
  }

  getBlockEditInlineComponent (type) {
    const settings = blockEditComponents[type] || {}
    return settings.inline
  }

  getBlockEditSidebarComponent (type) {
    const settings = blockEditComponents[type] || {}
    return settings.sidebar
  }

  hasParentBlock (block) {
    return block.props.parentBlock
  }
}

export const blockEditService = new BlockEditService()
